import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { MatChipInputEvent } from "@node_modules/@angular/material/chips";

@Component({
  selector: "app-tag-input",
  templateUrl: "./tag-input.component.html",
  styleUrls: ["./tag-input.component.css"],
  animations: [appModuleAnimation()],
})
export class TagInputComponent implements OnInit {
  @Input() availableTags: string[] = [];
  @Input() selectedTags: string[] = [];
  @Input() MexTagCount: number = 100;
  @Input() Label: string = "";
  @Output() selectedTagsChange = new EventEmitter<string[]>();

  @ViewChild("tagInput") tagInput!: ElementRef<HTMLInputElement>;

  separatorKeysCodes: number[] = [ENTER];

  tagCtrl = new FormControl("");

  filteredTags!: Observable<string[]>;

  ngOnInit(): void {
    this.filteredTags = this.tagCtrl.valueChanges.pipe(
      startWith(""),
      map((value) => this.filter(value || "")),
    );
  }

  private filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.availableTags.filter(
      (tag) =>
        tag.toLowerCase().includes(filterValue) &&
        !this.selectedTags.includes(tag),
    );
  }
  removeTag(tag: string): void {
    const index = this.selectedTags.indexOf(tag);

    if (index >= 0) {
      this.selectedTags.splice(index, 1);
      this.selectedTagsChange.emit(this.selectedTags);
    }
  }

  autocompleteSelected = false;

  selected(tag: string): void {
    this.autocompleteSelected = true;

    if (!this.selectedTags.includes(tag)) {
      this.selectedTags.push(tag);
      this.selectedTagsChange.emit(this.selectedTags);
    }

    this.tagInput.nativeElement.value = "";
    this.tagCtrl.setValue("");
  }

  addTag(event: MatChipInputEvent): void {
    setTimeout(() => {
      if (this.autocompleteSelected) {
        this.autocompleteSelected = false;
        return;
      }

      const value = (event.value || "").trim();

      if (!value) {
        return;
      }

      if (
        !this.selectedTags.some((x) => x.toLowerCase() === value.toLowerCase())
      ) {
        this.selectedTags.push(value);
        this.selectedTagsChange.emit(this.selectedTags);
      }

      event.chipInput?.clear();
      this.tagCtrl.setValue("");
    }, 10);
  }
}
